import * as React from "react";
import {FBFieldWithPriceBase, FBFieldWithPriceBaseState} from "FormBuilder/Fields/Core/FBFieldWithPriceBase";
import {PriceTypeEnum} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Options";
import {ContainerDataRetriever} from "FormBuilder/Core/FormBuilder.Model";

import {FBFieldBaseProps} from "FormBuilder/Fields/Core/FBFieldBase";
import {FBCheckBoxModel} from "./FBCheckBox.Model";
import {GetModel} from "FormBuilder/Events/GetModel";
import {FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {GetFieldOptions} from "FormBuilder/Events/GetFieldOptions";
import {GetField} from "FormBuilder/Events/GetField";
import {FBCheckBoxOptions} from "./FBCheckBox.Options";
import {OptionItem} from "FormBuilder/Fields/Options/OptionItem";
import {EventManager} from "shared/core/Events/EventManager";



export class FBCheckBox extends FBFieldWithPriceBase<FBDropDownProps,{}>{

    static defaultProps: Partial<FBDropDownProps> = {

    };

    constructor(props: FBDropDownProps) {
        super(props);
    }


    componentWillReceiveProps(nextProps: Readonly<FBDropDownProps>, nextContext: any): void {
        if(this.Model.Parent.IsDesign) {
            let selectedOptions = this.Model.Options.Options.find(x => x.Selected);
            this.Model.SelectedValues = this.Model.Options.Options.filter(x => x.Selected).map(x => x.Id);
            this.Model.Quantity = this.Model.Options.QuantityDefaultValue;
            this.Model.Refresh();
        }
    }

    SubRender() {
        if(this.Model.Options.ShowQuantitySelector&&this.Model.Options.PriceType!=PriceTypeEnum.quantity)
        {
            return(
                this.Model.Options.QuantityPosition == "bottom" || this.Model.Options.QuantityPosition == "right" ?
                    <React.Fragment>
                        {this.GetInput(this.Model.Options.QuantityPosition)}
                        {this.GetQuantityInput()}

                        {this.GetPriceOrRequiredBox()}

                    </React.Fragment>:
                    <React.Fragment>
                        {this.GetQuantityInput()}
                        {this.GetInput(this.Model.Options.QuantityPosition)}

                        {this.GetPriceOrRequiredBox()}

                    </React.Fragment>
            )
        }
        return(
            <React.Fragment>
                {this.GetInput('')}

                {this.GetPriceOrRequiredBox()}

            </React.Fragment>
        )


    }


    GetDynamicFieldNames(): any[] {
        return ['FBCheckBox'];
    }

    GetQuantityInput(){
        return(
            <div className={'rnTextFieldQuantity '+ this.Model.Options.QuantityPosition}>
                <div className={'rednaoLabel'}>
                    <label style={{fontWeight:'bold'}}>{this.Model.Options.QuantityLabel}</label>
                </div>
                <input className={'rnInputQuantity'} placeholder={this.Model.Options.QuantityPlaceholder} style={{width:'100%'}} type={'text'} value={this.Model.Quantity}
                       onChange={x=>{this.Model.Quantity=this.Model.ParseNumber(x.target.value as any);this.Model.Refresh()}}/>
            </div>

        )
    }


    GetInput(additionalClassNames:string){
        let maximumReached=this.Model.Options.MaximumNumberOfItems>0&&this.Model.Options.MaximumNumberOfItems<=this.Model.SelectedValues.length;

        return (
            <div className={'rnTextFieldInput '+ additionalClassNames}>
                {this.GetLabel()}
                {this.Model.Options.Options.map(option=>
                    <div key={option.Id} style={{display:'flex',alignItems:'center'}}>
                        <input disabled={maximumReached&&!this.Model.SelectedValues.some(x=>x==option.Id)} name={this.GetOptionId(option.Id)} id={this.GetOptionId(option.Id)} onChange={x=>this.Model.ToggleSelection(option.Id, x.target.checked)} type={'checkbox'} checked={this.Model.SelectedValues.indexOf(option.Id)>-1} value={option.Id}/>
                        <label className={'rnOptionItem'} htmlFor={this.GetOptionId(option.Id)} style={{marginLeft:5,cursor:"pointer"}}>{option.Label}</label>
                    </div>
                )}
            </div>

        );
    }

    public GetOptionId(optionId){
        let id=optionId.toString();
        id=this.props.Model.Options.Id+'_'+id;

        let formBuilder:ContainerDataRetriever=this.props.Model.FormBuilder;
        while(formBuilder.GetId()!=null)
        {
            id=formBuilder.GetId()+'_'+id;
            formBuilder=formBuilder.FormBuilder;
        }

        return 'field_'+id;
    }




}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FBDropDownProps extends FBFieldBaseProps{
    Model:FBCheckBoxModel;

}

interface FBDropDownState extends FBFieldWithPriceBaseState{


}


EventManager.Subscribe(GetModel,(event)=>{
    if(event.Options.Type==FieldTypeEnum.Checkbox)
        return new FBCheckBoxModel(event.Options as FBCheckBoxOptions,event.parent).Initialize(event.PreviousData);
});


EventManager.Subscribe(GetFieldOptions,(event)=>{
    if(event.Type==FieldTypeEnum.Checkbox)
        return new FBCheckBoxOptions();
});

EventManager.Subscribe(GetField,(event)=>{
    if(event.Model.Options.Type==FieldTypeEnum.Checkbox)
        return <FBCheckBox Model={event.Model as FBCheckBoxModel} />
});

//#endregion "My Region"